import { ColumnsType } from "antd/es/table";
import {
  DispatchInformation,
  OrdersTableDataResponseType,
} from "../../../../Types/DatabaseTabTypes";
import {
  getPrevDollorFormattedString,
  objectToString,
} from "../../../../Utilities";
import BlockIcon from "../../../../assets/images/lockIconOutline.svg";
import UnblockIcon from "../../../../assets/images/unlockIconOutline.svg";
import { objectToHtml } from "../../../../utils/textFormatUtils";
import { Popover } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import { MdModeEdit } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import styles from "./OrdersTable.module.scss";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import clsx from "clsx";

interface columnsParams {
  handleDispatch?: (data?: DispatchInformation) => void;
  handleEdit?: () => void;
  noActionDropFields: boolean;
  handleBlockUnblockOrder?: (orderId: string, blockAction: boolean) => void;
  blockedJob?: boolean;
}

export const getColumns = (
  params?: columnsParams,
): ColumnsType<OrdersTableDataResponseType> => [
  {
    title: "VENDOR",
    key: "vendor",
    align: "center",
    dataIndex: "vendor",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val || "-"}
      </span>
    ),
  },
  {
    title: "MATERIAL CATEGORY",
    key: "category",
    align: "center",
    dataIndex: "category",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val || "-"}
      </span>
    ),
  },
  {
    title: "MATERIAL SUBCATEGORY",
    key: "subCategory",
    align: "center",
    dataIndex: "subCategory",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val || "-"}
      </span>
    ),
  },
  {
    title: "MATERIAL NAME",
    key: "label",
    align: "center",
    dataIndex: "label",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val || "-"}
      </span>
    ),
  },
  {
    title: "ESTIMATED QTY",
    key: "truckType",
    align: "center",
    dataIndex: "truckType",
    render: (val, record) => {
      const estimatedQty = record?.quantity?.estimated
        // Filter out items that don't have a quantity or type
        ?.filter((item) => item.quantity != null && item.type)
        ?.map((item) => `${item.quantity} ${item.type}`)
        .join(", ");
      return (
        <span
          className={clsx("table-font-mobile", {
            [styles.blockedOrder]: record?.isBlocked,
          })}
        >
          {estimatedQty || "-"}
        </span>
      );
    },
  },
  {
    title: "INVOICED QTY",
    key: "invoiceQty",
    align: "center",
    dataIndex: "invoiceQty",
    render: (val, record) => {
      const invoicedQty = record?.quantity?.invoiced
        // Filter out items that don't have a quantity or type
        ?.filter((item) => item.quantity != null && item.type)
        ?.map((item) => `${item.quantity} ${item.type}`)
        .join(", ");
      return (
        <span
          className={clsx("table-font-mobile", {
            [styles.blockedOrder]: record?.isBlocked,
          })}
        >
          {invoicedQty || "-"}
        </span>
      );
    },
  },
  {
    title: "EQUIPMENT",
    key: "truckType",
    align: "center",
    dataIndex: "truckType",
    render: (val, record) => {
      const equipment = Array.isArray(val) ? val.join(", ") : val;
      return (
        <span
          className={clsx("table-font-mobile", {
            [styles.blockedOrder]: record?.isBlocked,
          })}
        >
          {equipment || "-"}
        </span>
      );
    },
  },
  {
    title: "MATERIAL COST",
    key: "materialCost",
    align: "center",
    dataIndex: "materialCost",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? getPrevDollorFormattedString(val) : "-"}
      </span>
    ),
  },
  {
    title: "MATERIAL PRICE",
    key: "materialPrice",
    align: "center",
    dataIndex: "materialPrice",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? getPrevDollorFormattedString(val) : "-"}
      </span>
    ),
  },
  {
    title: "TRUCKING COST",
    key: "truckingCost",
    align: "center",
    dataIndex: "truckingCost",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? getPrevDollorFormattedString(val) : "-"}
      </span>
    ),
  },
  {
    title: "TRUCKING PRICE",
    key: "truckingPrice",
    align: "center",
    dataIndex: "truckingPrice",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? getPrevDollorFormattedString(val) : "-"}
      </span>
    ),
  },
  {
    title: "LANDED PRICE",
    key: "landedPrice",
    align: "center",
    dataIndex: "landedPrice",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? getPrevDollorFormattedString(val) : "-"}
      </span>
    ),
  },
  {
    title: "DRIVE MILES",
    key: "milesData",
    align: "center",
    dataIndex: "milesData",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? val : "-"}
      </span>
    ),
  },
  {
    title: "DRIVE MINUTES",
    key: "duration",
    align: "center",
    dataIndex: "duration",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedOrder]: record?.isBlocked,
        })}
      >
        {val != null && val !== "" ? val : "-"}
      </span>
    ),
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    align: "right",
    render: (_, record) => {
      return (
        <ConditionalRender visible={!!!params?.blockedJob}>
          <Popover
            placement={PlacementPositions.LEFT}
            content={
              <>
                <ConditionalRender visible={!record?.isBlocked}>
                  {params?.noActionDropFields && (
                    <div
                      className={styles.PopoverContent}
                      onClick={params?.handleEdit}
                    >
                      <MdModeEdit />
                      Edit
                    </div>
                  )}
                  <div
                    className={styles.PopoverContent}
                    onClick={() =>
                      params?.handleDispatch({
                        id: record?.id,
                        ...record?.dispatchInformation,
                      })
                    }
                  >
                    <FaEye />
                    Dispatch Info
                  </div>
                  <div
                    className={styles.PopoverContent}
                    onClick={() =>
                      params?.handleBlockUnblockOrder(record?.id, true)
                    }
                  >
                    <img alt={"block"} src={BlockIcon} />
                    Block
                  </div>
                </ConditionalRender>
                <ConditionalRender visible={record?.isBlocked}>
                  <div
                    className={styles.PopoverContent}
                    onClick={() =>
                      params?.handleBlockUnblockOrder(record?.id, false)
                    }
                  >
                    <img alt={"unblock"} src={UnblockIcon} />
                    Unblock
                  </div>
                </ConditionalRender>
              </>
            }
          >
            <EllipsisOutlined
              style={{ fontSize: "30px", color: "#C3C8CD" }}
              className="action-ellipsis-button"
            />
          </Popover>
        </ConditionalRender>
      );
    },
  },
];

export const DispatchInfoModalWidth = "45rem";

export const MailMessages = {
  SUCCESS: "Mail sent successfully!",
  FAILURE: "Failed to sent mail!",
  DISPATCH_COPIED: "Copied to clipboard successfully!",
};

export const getDispatchInfoForCopy = (dispatchInformation) => {
  return {
    Date: dispatchInformation?.date ?? "-",
    ["Customer Name"]: dispatchInformation?.companyName ?? "-",
    ["Job Name"]: dispatchInformation?.jobName ?? "-",
    ["Primary contact"]: dispatchInformation?.contactName ?? "-",
    ["Primary contact number"]: dispatchInformation?.phone ?? "-",
    ["Job Type"]: dispatchInformation?.jobType ?? "-",
    Equipment: dispatchInformation?.truckType?.join(", ") ?? "-",
    ["Pickup Location"]: `${dispatchInformation?.pickUpAddress}, (${dispatchInformation?.pickUpLatLng?.lat}, ${dispatchInformation?.pickUpLatLng?.lng})`,
    ["Delivery Location"]: `${dispatchInformation?.dropoff}, (${dispatchInformation?.dropOffLatLng?.lat}, ${dispatchInformation?.dropOffLatLng?.lng})`,
    ["Rate Information"]: `${getPrevDollorFormattedString(dispatchInformation?.truckingPrice)} per ${dispatchInformation?.truckingPriceType} ${dispatchInformation?.minimumHours ? `, ${dispatchInformation?.minimumHours} - Hour minimum` : ""}`,
  };
};

export const copyObjectAsRich = async (obj) => {
  const html = objectToHtml(obj, { separator: " : " });
  const plain = objectToString(obj, { separator: " : " });
  try {
    const blobPlain = new Blob([plain], { type: "text/plain" });
    const blobHtml = new Blob([html], { type: "text/html" });
    await navigator.clipboard.write([
      new ClipboardItem({
        "text/plain": blobPlain,
        "text/html": blobHtml,
      }),
    ]);
  } catch (err) {
    console.error("Rich copy failed, fallback to plain.", err);
    await navigator.clipboard.writeText(plain);
  }
};

export const BlockUnblockOrderConstants = {
  BLOCK_ORDER_TITLE: "Block Order",
  UNBLOCK_ORDER_TITLE: "Unblock Order",
  BLOCK_ORDER_MESSAGE: "Are you sure you want to block selected order ?",
  UNBLOCK_ORDER_MESSAGE: "Are you sure you want to unblock selected order ?",
};
